import { createLocalVue, shallowMount } from '@vue/test-utils';
import Vuex from 'vuex';

/**** TEST MODULE ****/
import ColorMatchSwatchSelector from './ColorMatchSwatchSelector';

/**** MOUNTING OPTIONS ****/
function createWrapper() {
  const store = new Vuex.Store({
    modules: store_modules,
  });

  return shallowMount(ColorMatchSwatchSelector, {
    attachToDocument,
    localVue,
    mocks,
    methods,
    provide,
    store,
    stubs,
  });
}

let attachToDocument = false;
const localVue = createLocalVue();
localVue.use(Vuex);

const methods = {};
const mocks = {};
const provide = {};
const store_modules = {};
const stubs = [];
let wrapper;

/**** TESTS ****/
describe('ColorMatchSwatchSelector', function() {
  provide['getObjProperty'] = jest.fn();
  methods['getWavyBackieMediaId'] = jest.fn(); 
  store_modules['colorAdvisor'] =  {
    namespaced: true,
    state: {
      colorMatches: {
        data: {},
        updated: 0,
      }, 
    },
    actions: {
      updateColorMatches: jest.fn(),
    }
  };

  store_modules['moreColorOptions'] = {
    namespaced: true,
    actions: {
      openPlaygroundModal: jest.fn(),
      setSelectedColor: jest.fn(),
    }
  };

  stubs.push('HorizontalScroller', 'ImgBox', 'Stars');

  describe('beforeMount', function() {
    wrapper = createWrapper();

    it('tries to load colorMatches if colorMatches has not been initialized', () => {
      expect(store_modules['colorAdvisor'].actions.updateColorMatches.mock.calls.length).toBe(1);
    });
  });

  describe('color matches shown', () => {
    const colorMatchTexts = {
      bestMatch: 'best match',
      mostPopular: 'most popular',
      customerMatch: 'your choice',
      coloristMatch: `colorist's choice`,
      translatorMatch: 'translator results',
    };

    const colorMatches = store_modules.colorAdvisor.state.colorMatches;

    beforeEach(() => {
      colorMatches.data = {
        mostPopular: {
          code: '7NCG',
        },
        bestMatch: { 
          code: '8NVA',
        }, 
        translatorMatch: {
          code: '9NA',
        },
        coloristMatch: {
          code: '9NV',
        },
        customerMatch: {
          code: '9NGV',
        },
      };
    });

    it('shows colors in order of bestMatch > mostPopular > customerMatch > coloristMatch > translatorMatch', () => {
      wrapper = createWrapper(); 

      const swatches = wrapper.findAll('.swatch .match-type');
      expect(swatches.wrappers[0].text()).toEqual(colorMatchTexts.bestMatch); 
      expect(swatches.wrappers[1].text()).toEqual(colorMatchTexts.mostPopular); 
      expect(swatches.wrappers[2].text()).toEqual(colorMatchTexts.customerMatch); 
      expect(swatches.wrappers[3].text()).toEqual(colorMatchTexts.coloristMatch); 
      expect(swatches.wrappers[4].text()).toEqual(colorMatchTexts.translatorMatch); 
    });

    it('does not show customerMatch if bestMatch or mostPopular has the same color', ()=> {
      let swatches, customerMatch, priorityMatch;

      ['bestMatch', 'mostPopular'].map(priorityMatchKey => {
        colorMatches.data.customerMatch.code = colorMatches.data[priorityMatchKey].code;
        wrapper = createWrapper();

        swatches = wrapper.findAll('.swatch .match-type');
        customerMatch = swatches.wrappers.filter(d => d.text() === 'your choice');
        priorityMatch = swatches.wrappers.filter(d => d.text() === colorMatchTexts[priorityMatchKey]);

        expect(customerMatch.length).toEqual(0);
        expect(priorityMatch.length).toEqual(1); 
      });
    });

    it('does not show coloristMatch if bestMatch, mostPopular, or customerMatch has the same color', () => {
      let swatches, coloristMatch, priorityMatch;

      ['bestMatch', 'mostPopular', 'customerMatch'].map(priorityMatchKey => {
        colorMatches.data.coloristMatch.code = colorMatches.data[priorityMatchKey].code;
        wrapper = createWrapper();

        swatches = wrapper.findAll('.swatch .match-type');
        coloristMatch = swatches.wrappers.filter(d => d.text() === "colorist's choice");
        priorityMatch = swatches.wrappers.filter(d => d.text() === colorMatchTexts[priorityMatchKey]);

        expect(coloristMatch.length).toEqual(0);
        expect(priorityMatch.length).toEqual(1); 
      });
    });
  });
});
